import { AbstractControl, ValidationErrors } from '@angular/forms';
import { InputValidationErrors } from '../../input-error';
import { inputValidators } from './input-validators';
import { InputErrorTranslationKeys } from '../../../configuration';

const fullEmail = (): ((control: AbstractControl) => ValidationErrors) => (control: AbstractControl) => {
  const errors: InputValidationErrors = {};
  const fullEmailRegexp = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$', 'u');
  if (!fullEmailRegexp.test(control.value)) {
    errors.email = {
      errorTranslationKey: InputErrorTranslationKeys.InvalidEmail,
    };
  }
  return errors;
};

export const fullEmailValidators = [inputValidators.required, inputValidators.maxLength(100), fullEmail()];
